import { render, staticRenderFns } from "./VolunteerProfileInterestsDialog.vue?vue&type=template&id=22609f54&scoped=true"
import script from "./VolunteerProfileInterestsDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileInterestsDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileInterestsDialog.vue?vue&type=style&index=0&id=22609f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22609f54",
  null
  
)

export default component.exports